import { Icon, IconProps } from './Icon';

export type ExpandDownProps = IconProps;

export const ExpandDown = (props: ExpandDownProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M9.717 17.217a.4.4 0 0 0 .566 0l3.034-3.034a.4.4 0 0 0-.283-.683H6.966a.4.4 0 0 0-.283.683l3.034 3.034ZM9.717 2.783a.4.4 0 0 1 .566 0l3.034 3.034a.4.4 0 0 1-.283.683H6.966a.4.4 0 0 1-.283-.683l3.034-3.034Z" fill="currentcolor" fillOpacity=".6"/><path stroke="currentcolor" strokeLinecap="round" d="M3.5 10h13"/>
  </Icon>
)
